import { render, staticRenderFns } from "./Creditors.vue?vue&type=template&id=0dadcd88&"
import script from "./Creditors.vue?vue&type=script&lang=js&"
export * from "./Creditors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports